module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticStyle: {
      "min-height": "100%"
    },
    attrs: {
      "dark": "",
      "flat": ""
    }
  }, [(_vm.request.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": 2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comm.backend_used === "services.backends.email.EmailBackend") ? _c('v-card-text', [_c('div', [_c('div', {
    staticClass: "overline"
  }, [_vm._v("To:")]), _vm._l((_vm.comm.recipient_emails), function(email) {
    return _c('v-chip', {
      key: email,
      staticClass: "v-chip--x-small"
    }, [_vm._v(_vm._s(email))])
  })], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "overline mt-2"
  }, [_vm._v("Subject:")]), _vm._v(" " + _vm._s(_vm.comm.subject) + "\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "mt-4 overline"
  }, [_vm._v("Message:")]), _vm._v(" "), _c('div', {
    staticClass: "block",
    domProps: {
      "innerHTML": _vm._s(_vm.parsedMessage)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.comm.backend_used === "services.backends.zoomconnect.ZoomSMSBackend") ? _c('v-card-text', [_c('div', [_c('span', {
    staticClass: "overline"
  }, [_vm._v("To:")]), _c('v-chip', {
    staticClass: "v-chip--x-small"
  }, [_vm._v(_vm._s(_vm.comm.recipient_phone_number))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "mt-4 mb-2 overline"
  }, [_vm._v("Message:")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "pa-2",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.comm.short_message.trim()))]), _vm._v("\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('h4', {
    staticClass: "overline ml-3 mb-2"
  }, [_vm._v("Status history")]), _vm._v(" "), _vm._l((_vm.comm.communicationstatus), function(status) {
    return _c('v-list-tile', {
      key: status.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(status.status))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.dateformat(status.created_date, 'ddd DD MMM YYYY H:mma')))])], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bbc117e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/communications/CommunicationCard.vue
// module id = 1346
// module chunks = 9